'use client';

import * as a from "react";
import p from "../lib/IconBase.es.js";
import e$1 from "../defs/DownloadSimple.es.js";
const e = a.forwardRef((a$1, m) => /* @__PURE__ */ a.createElement(p, { ref: m, ...a$1, weights: e$1 }));
e.displayName = "DownloadSimpleIcon";
const l = e;
export {
  l as DownloadSimple,
  e as DownloadSimpleIcon
};
